"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewDataRequestLink extends new_item_1.default {
    constructor(newDataRequestLink) {
        super();
        this.dataRequestId = newDataRequestLink.dataRequestId;
        this.expiresTime = newDataRequestLink.expiresTime;
        this.url = newDataRequestLink.url;
        this.expires = newDataRequestLink.expires;
    }
}
exports.default = NewDataRequestLink;
//# sourceMappingURL=new-dataRequestLink.js.map